import React from 'react';
import { Star, Quote } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';
import { Card, CardContent } from './ui/card';
import { testimonialsData } from '../mockData';

export const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-20 bg-[#F5F5F5]">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Client <span className="text-[#FF6B00]">Testimonials</span>
          </h2>
          <div className="w-24 h-1 bg-[#FF6B00] mx-auto mb-6"></div>
          <p className="text-[#333333] text-lg max-w-2xl mx-auto">
            Hear what our satisfied clients have to say about their experience with Lalit Interior
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="max-w-5xl mx-auto">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {testimonialsData.map((testimonial) => (
                <CarouselItem key={testimonial.id} className="md:basis-1/2 lg:basis-1/2">
                  <Card className="bg-white border-0 shadow-lg hover:shadow-2xl transition-shadow duration-300 h-full">
                    <CardContent className="p-8">
                      {/* Quote Icon */}
                      <div className="mb-4">
                        <Quote className="text-[#FF6B00] opacity-20" size={48} />
                      </div>

                      {/* Rating Stars */}
                      <div className="flex mb-4">
                        {[...Array(testimonial.rating)].map((_, index) => (
                          <Star
                            key={index}
                            className="text-[#FF6B00] fill-current"
                            size={20}
                          />
                        ))}
                      </div>

                      {/* Quote */}
                      <p className="text-[#333333] text-base mb-6 leading-relaxed italic">
                        "{testimonial.quote}"
                      </p>

                      {/* Client Info */}
                      <div className="border-t border-gray-200 pt-4">
                        <p className="font-bold text-black text-lg">
                          {testimonial.name}
                        </p>
                        <p className="text-[#FF6B00] text-sm font-medium">
                          {testimonial.position}
                        </p>
                        {testimonial.company && (
                          <p className="text-[#333333] text-sm font-semibold">
                            {testimonial.company}
                          </p>
                        )}
                        <p className="text-[#666666] text-sm">
                          {testimonial.location}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex" />
            <CarouselNext className="hidden md:flex" />
          </Carousel>
        </div>
      </div>
    </section>
  );
};
